<template>
  <div>
    <v-card>
      <v-card-title>Imagenes de Pruebas de Entrega</v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="d-flex child-flex" cols="10" sm="8" md="8">
              <v-text-field label="Archivo" readonly v-model="imgUrl"></v-text-field>
          </v-col>
          <v-col cols="2" sm="4" md="4">
            <v-btn color="primary" @click="pickFoto()" rounded outlined
              >Seleccionar...<v-icon>mdi-folder-open</v-icon></v-btn
            >
            <input
              type="file"
              ref="filefoto"
              style="display: none"
              @change="onFotoPicked"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-space-around">
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click="uploadImage()">
              Subir... <v-icon>mdi-upload</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-card>
            <v-simple-table>
                <thead>
                    <tr>
                        <th>Archivo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(archivo, index) in files" :key="index">
                        <td>{{archivo}}</td>
                        <td>
                            <v-btn icon color="blue" @click="descargarImagenPod(archivo)">
                                <v-icon>mdi-eye-check</v-icon>
                                </v-btn>
                                <v-btn icon color="blue" @click="descargarImagenPod(archivo, true)">
                                <v-icon>mdi-cloud-download</v-icon>
                                </v-btn>
                                <v-btn icon color="red" @click="eliminarImagenPod(archivo)">
                                <v-icon>mdi-delete</v-icon>
                                </v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import apicon from '../plugins/apicon';
import utils from '../utils/utils';
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  created: function () {},
  data() {
    return {
      srcImg: null,
      imageFile: null,
      imgUrl: null,
      files: [],
    };
  },
  methods: {
    pickFoto: function () {
      this.$refs.filefoto.click();
    },
    onFotoPicked: function (e) {
      const files = e.target.files;
      var self = this;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf(".") <= 0) {
          return;
        }
        this.imageFile = files[0];
        this.imgUrl = files[0].name;
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          self.srcImg = fr.result;
        });
      }
    },
    uploadImage: async function () {
      let fd = new FormData();
      fd.append("image", this.imageFile);
      await apicon
        .saveDataApi(apicon.getApiBaseUrl() + "guias/uploadpod/" + this.id, fd)
        .then((result) => {
            this.getFiles();
          console.log(result);
        });
    },
    getFiles: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'getimagenespod/' + this.id)
        .then((result) => {
            this.files = result;
        });
    },
    descargarImagenPod: function (imagen,descargar = false) {
      let ext = imagen.substring(imagen.indexOf("."));
      let imgName = imagen.replace(ext,'');
      let tipo = null;
      switch(ext){
          case '.pdf':
            tipo = 'application/pdf';
            break;
          case '.gif':
            tipo = 'image/gif';
            break;
          case '.jpg':
            tipo = 'image/jpg'
            break;
          case '.png':
            tipo = 'image/png';
            break;
          case '.webp':
            tipo = 'image/png';
            break;
          default :
            null
            break;

      }
      //Verificar si selecciono vista previa y no se puede
      if(!descargar == true && tipo == null){
        this.$swal("El documento seleccionado no admite la vista previa");
        return;
      }
      apicon
        .downloadDataApi(apicon.getApiBaseUrl() + "downimagenpod", {
          imagen: imagen,
        })
        .then((result) => {
          utils.forceFileDownload(
            result,
            ext,
            !descargar,
            imgName,
            tipo
          );
        });
    },
    eliminarImagenPod(imagen){
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon.saveDataApi(apicon.getApiBaseUrl() + 'delimagenpod',{imagen : imagen})
            .then((result) => {
                self.getFiles();
                this.$swal(result.message);
            });
        }
      });
    },
  },
  mounted: function () {
      this.getFiles();
  },
};
</script>

<style>
</style>
